function useStyles() {
    return {
        container: ({ reassignButton, areThereApprovers }: { reassignButton: boolean; areThereApprovers: boolean }) => {
            return {
                height: '100%',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                padding: '24px 0px',
                gap: reassignButton ? 0 : 2,
                '& .container': {
                    backgroundColor: 'blue.100',
                    padding: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    height: areThereApprovers ? '50%' : '100%',
                    minHeight: '280px'
                },
                '& .scroll_container': {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    maxHeight: '300px',
                    overflowY: 'auto',
                    padding: '2px'
                }
            }
        },
    }
}

export { useStyles }